import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const emailNewsletterApi = {
  /**
   * @param {number} userId
   * @param {boolean} [forceResend]
   */
  sendNewsletterToSubscriber: (userId, forceResend = false, config = {}) =>
    mod.post(`/email/send-newsletter/${userId}`, null, {
      ...config,
      params: { force_resend: forceResend, ...config.params },
    }),

  /** @param {boolean} [forceResend] */
  sendNewsletterToAll: (forceResend = false, config = {}) =>
    mod.post('/email/send-newsletter-all', null, {
      ...config,
      params: { force_resend: forceResend, ...config.params },
    }),

  /**
   * Send to a specific list of subscriber IDs.
   * @param {{ user_ids: number[] }} body
   * @param {boolean} [forceResend]
   */
  sendBatch: (body, forceResend = false, config = {}) =>
    mod.post('/email/send-newsletter-batch', body, {
      ...config,
      params: { force_resend: forceResend, ...config.params },
    }),

  /**
   * Preview the rendered HTML email for a subscriber before sending.
   * @param {number} userId
   */
  preview: (userId, config) => mod.get(`/email/preview/${userId}`, config),

  /**
   * Preview digest content (topics + articles) for a subscriber.
   * @param {number} userId
   */
  userTopics: (userId, config) => mod.get(`/email/user-topics/${userId}`, config),

  /**
   * @param {{ userId?: number; skip?: number; limit?: number }} [params]
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  listNewsletterLogs: (params = {}, config = {}) =>
    mod.get('/newsletter-logs/', { ...config, params }),

  /** @param {number} id */
  getLog: (id, config) => mod.get(`/newsletter-logs/${id}`, config),

  /** @param {number} id */
  removeLog: (id, config) => mod.delete(`/newsletter-logs/${id}`, config),
};
